import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const url = process.env.REACT_APP_API_BASE_GEOSERVER;
function LeafletMap() {
  const { user } = useSelector((state) => state.auth);
  const [iframeHeight, setIframeHeight] = useState(window.innerHeight - 100);

  const [selectedOrg, setSelectedOrg] = useState(
    localStorage.getItem("selectedOrg")
  );
  const selectedCounty = localStorage.getItem("selectedCounty");

  useEffect(() => {
    const updateHeight = () => {
      const availableHeight = window.innerHeight - 190;
      setIframeHeight(availableHeight);
    };

    updateHeight();
    window.addEventListener("resize", updateHeight);

    return () => window.removeEventListener("resize", updateHeight);
  }, []);
  return (
    <div className="mt-[1.25rem]">
      <iframe
        src={
          selectedOrg === "COUNTY" && user?.usrType === "SDI"
            ? `${url}/counties_dashboard.php?county=${selectedCounty}`
            : user?.usrType === "SDI" &&
              selectedOrg != "NIA" &&
              selectedOrg != "NWHSA"
            ? `${url}/sdi_dashboard.php`
            : user?.usrType === "NIA"
            ? `${url}/nia_dashboard.php`
            : user?.usrType === "NWHSA"
            ? `${url}/nwhsa_dashboard.php`
            : selectedOrg == "NIA"
            ? `${url}/nia_dashboard.php`
            : selectedOrg == "NWHSA"
            ? `${url}/nwhsa_dashboard.php`
            : ""
        }
        width="100%"
        height={iframeHeight}
        style={{ border: "none" }}
        title="Dynamic Iframe"
      />
    </div>
  );
}

export default LeafletMap;

 